<template>
  <master-layout pageTitle="Store analytics">
    <ion-loading
    v-if="loading"
    :is-open="loading"
    cssClass="my-custom-class"
    message="Loading..."
    ></ion-loading>
    <ion-content v-else>
      <iframe id="googleDataStudioAnalyticsIframe" style="width: 100%; height: calc(100vh - 56px); border: none;" :src="iframeUrl" title="Analytics" allowfullscreen></iframe>
    </ion-content>
  </master-layout>
</template>

<script>
import { mapGetters } from "vuex";
import jwtInterceptor from '/src/shared/jwtInterceptor';
export default {
  data() {
    return {
      loading: true,
      iframeUrl: ""
    }
  },
  ionViewWillEnter(){
    this.Get_iframeUrl();
  },
  computed: {
    ...mapGetters({
      authData: "auth/getAuthData"
    }),
  },
  methods: {
    Get_iframeUrl() {
      if(this.user.enterprise_Name == 'lbc'){
        this.loading = false;

        this.iframeUrl = "https://datastudio.google.com/embed/reporting/16jPemm2YuoevD6SKzvxSH2sZZyy8gY6x/page/b2XIB";
      }
      else if(this.user.enterprise_Name == 'samsungid'){
        this.loading = false;

        this.iframeUrl = "https://datastudio.google.com/embed/reporting/7497eb2d-dcdb-4aa7-a95f-e8d791f26a30/page/PStJB";
      }
      else if(this.user.enterprise_Name == 'lakmeindia'){
        this.loading = false;

        this.iframeUrl = "https://datastudio.google.com/embed/reporting/1dcpRkHhDIKWHQfaSs255PVaqIX-yYr4-/page/8k5TB";
      }
      else{
        this.getGoogleDataStudioUrl();
      }
    },
    async getGoogleDataStudioUrl() {
      try {
        let reqBody = {
          userid: this.authData.authkey
        }
        let getGDSUrlResponse = await jwtInterceptor.post(this.environment('VUE_APP_ROOT_API') + "analytic-url", reqBody);
        if ((getGDSUrlResponse.status == 200 || getGDSUrlResponse.status == 201) && getGDSUrlResponse.data.success) {
          this.loading = false;

          var filteredUrl = getGDSUrlResponse.data.url.split('params=');
          var url_part1 = filteredUrl[0] +"params=%7B";
          var url_lastPart = "%7D";
          
          var url_key = filteredUrl[1];
          url_key = url_key.split('seller_key%22:%22');
          url_key = url_key[1];

          if(url_key.indexOf('%7D') > -1){
            url_key = url_key.split('%7D');
            url_key = url_key[0];
          }

          var sellerKeys_part = "%22jumper0.seller_key%22:%22"+ url_key +"%22,%22jumper1.seller_key%22:%22"+ url_key +"%22,%22jumper2.seller_key%22:%22"+ url_key +"%22,%22jumper3.seller_key%22:%22"+ url_key +"%22,%22jumper4.seller_key%22:%22"+ url_key +"%22,%22jumper5.seller_key%22:%22"+ url_key +"%22,%22jumper6.seller_key%22:%22"+ url_key +"%22";

          if(this.redRibbon_ph_manila == true){
            url_part1 = "https://datastudio.google.com/embed/reporting/1jDXbjZ9Vdi-0d1EPmHDblQZ7r1oQHHaN/page/90WUB?params=%7B";
          }
          else if(this.user.enterprise_Name == 'smretail_ph'){
            url_part1 = "https://datastudio.google.com/embed/reporting/4a485002-c2b2-49f8-95a2-186672f5d655/page/28VtB?params=%7B";
          }

          this.iframeUrl = url_part1 +""+ sellerKeys_part +""+ url_lastPart;
        } else {
          this.loading = false;

          if(getGDSUrlResponse.data.errorMessage && getGDSUrlResponse.data.errorMessage.length) {
            this.updateToast({
              open: true,
              message: getGDSUrlResponse.data.errorMessage,
              type: "danger"
            })
          } else {
            this.updateToast({
              open: true,
              message: "Something went wrong",
              type: "danger"
            })
          }
        }
      } catch (error) {
        this.loading = false;
        
        console.log("Exception: ", error);
        this.updateToast({
          open: true,
          message: "Something went wrong!",
          type: "danger"
        })
      }
    }
  }
}
</script>